import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Modal } from 'components/modal/Modal';
import { GlamboxCookieStore } from 'core/glambox/GlamboxCookieStore';

import ModalStyles from 'components/general/SubscriberModals.module.scss';
import { AnalyticsRenderDispatch } from './AnalyticsRenderDispatch';
import { AnalyticsActionLink } from './AnalyticsActionLink';
import { AnalyticsActionNav } from './AnalyticsActionNav';
import { GlamboxLocalStore } from 'core/glambox/GlamboxLocalStore';
import { ContactSupportOutlined } from '@material-ui/icons';

class SubscriberModals extends Component {
  /**
   * @type {GlamboxCookieStore}
   */
  cookieHandle = null;

  constructor(props) {
    super(props);

    this.storageHandle = new GlamboxLocalStore();
    this.cookieHandle = new GlamboxCookieStore(
      '/',
      process.env.REACT_APP_GB_COOKIE_ROOT,
      new Date(Date.now() + 60 * 60 * 3 * 1000),
      null
    );
    this.cookieHandle.expires = new Date(
      Date.now() + 60 * 60 * 3 * 1000
    ).toUTCString();
    let numberOfModalsMgm = 3; /*colocar o número de modais funcionando no momento*/
    let cookieMgm = this.cookieHandle.get('mgmCookieModal');
    let cookieGp = this.cookieHandle.get('gpCookieModal');
    let cookieMgmCount = this.cookieHandle.get('mgmCookieModalCount');
    let cookieGpCount = this.cookieHandle.get('gpCookieModalCount');
    let showMgm = false,
      showGp = false,
      gpCount = 0,
      mgmCount = 0;

    cookieGpCount = !cookieGpCount ? 0 : parseInt(cookieGpCount);
    cookieMgmCount = !cookieMgmCount ? 0 : parseInt(cookieMgmCount);

    if (this.props.person.person) {
      if (this.props.person.person.personStatus === 14) {
        showGp = true;

        gpCount = parseInt(cookieGpCount);

        if (isNaN(gpCount) || !gpCount) {
          gpCount = 0;
        }

        this.cookieHandle.set(
          'gpCookieModalCount',
          cookieGpCount + 1 >= 2 ? 0 : cookieGpCount + 1
        );
      } else if (this.props.person.person.personStatus !== 14) {
        showMgm = true;

        mgmCount = parseInt(cookieMgmCount);

        if (isNaN(mgmCount) || !mgmCount) {
          mgmCount = 0;
        }

        this.cookieHandle.set(
          'mgmCookieModalCount',
          cookieMgmCount + 1 >= numberOfModalsMgm ? 0 : cookieMgmCount + 1
        );
      }

      let params = new URLSearchParams(window.location.search);
      if (params.get('modals') === 'off') {
        showGp = false;
        showMgm = false;
      }
    }

    this.state = {
      facebookLog: this.storageHandle.get('loggedWithFacebook'),
      person: this.props.person.person,
      mgm: showMgm,
      gp: showGp,
      gpCount,
      mgmCount,

      igId: '',
      userDetails: [],
      userInsightsDay: [],
      userInsightsLifetime: [],
      mediaList: [],
      mediaDetailsList: [],
      mediaInsights: [],
    };
    console.log(this.state.person);
  }

  toggleMgm = () => {
    this.setState(
      {
        mgm: !this.state.mgm,
      },
      () => {
        this.forceUpdate();
      }
    );
  };

  toggleGp = () => {
    this.setState(
      {
        gp: !this.state.gp,
      },
      () => {
        this.forceUpdate();
      }
    );
  };

  componentDidMount() {
    const { person } = this.props;
  }

  renderMgmModal = () => {
    switch (this.state.mgmCount) {
      default:
        return (
          <Modal
            visible={this.state.mgm}
            onCloseModal={this.toggleMgm}
            useDefaultDialog={false}
          >
            <div id={ModalStyles['mgmExtaBox']}>
              <div className={ModalStyles['content']}>
                <img
                  className={ModalStyles['logo']}
                  src={
                    'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21033.png'
                  }
                  alt={'quer ganhar uma caixa extra?'}
                />
                <p>
                  Vem descobrir como <strong>garantir a sua!</strong>
                </p>
                <a
                  className={ModalStyles['link']}
                  href="/chama-as-amigas/concurso?itm_source=glambox.com.br&itm_medium=referral&itm_campaign=modal-chama-as-amigas&itm_content=caixa-extra"
                >
                  <button onClick={this.toggleMgm}>SAIBA MAIS</button>
                </a>
              </div>
            </div>
          </Modal>
        );

      case 1:
        return (
          <Modal
            visible={this.state.mgm}
            onCloseModal={this.toggleMgm}
            useDefaultDialog={false}
          >
            <div id={ModalStyles['mgmGlamFriday']}>
              <div className={ModalStyles['content']}>
                <img
                  className={ModalStyles['logo']}
                  src={
                    'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21064.png'
                  }
                  alt={'Ganhe um ano de GLAMBOX GRÁTIS!'}
                />
                <p>
                  Você pode ganhar até 5 produtos extras trazendo suas amigas
                  para a Glambox!
                </p>
                <a
                  className={ModalStyles['link']}
                  href="https://minha.glambox.com.br/chama-as-amigas/concurso?itm_source=glambox.com.br&itm_medium=referral&itm_campaign=modal-chama-as-amigas&itm_content=chame-e-ganhe"
                >
                  <button onClick={this.toggleMgm}>SAIBA MAIS</button>
                </a>
              </div>
            </div>
          </Modal>
        );
    }
  };

  renderGpModal = () => {
    switch (this.state.gpCount) {
      default:
        /*return (
          <Modal visible={this.state.gp} onCloseModal={this.toggleGp} useDefaultDialog={false}>
            <div
              id={ModalStyles['superbox']}
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
              <a
                href="https://minha.glambox.com.br/glampartner/plano-de-desenvolvimento"
                className={ModalStyles['hidden-sm']}
              >
                <img
                  src="https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_20391.gif"
                  alt="Promo Relampago"
                />
              </a>
              <a
                href="https://minha.glambox.com.br/glampartner/plano-de-desenvolvimento"
                className={ModalStyles['hidden-md']}
              >
                <img
                  src="https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_20392.gif"
                  alt="Promo Relampago"
                />
              </a>
            </div>
          </Modal>
        );*/
        return <></>;
    }
  };

  render() {
    return <>{this.state.gp ? this.renderGpModal() : this.renderMgmModal()}</>;
  }
}

const mapStateToProps = state => ({
  person: state.person.data,
  token: state.token,
});

SubscriberModals = connect(mapStateToProps)(SubscriberModals);

export { SubscriberModals };
